// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yfNUjw {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: var(--spacing-3);
}

.bEaGfS {
  color: var(--text-neutral-dark);
  font-size: var(--type-title-lg-font-size);
  font-weight: var(--type-title-lg-font-weight);
  line-height: var(--type-title-lg-line-height);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargePaymentHeader/RechargePaymentHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;AAC/C","sourcesContent":[".header {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.title {\n  color: var(--text-neutral-dark);\n  font-size: var(--type-title-lg-font-size);\n  font-weight: var(--type-title-lg-font-weight);\n  line-height: var(--type-title-lg-line-height);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `yfNUjw`,
	"title": `bEaGfS`
};
module.exports = ___CSS_LOADER_EXPORT___;
